<template>
    <div class="flex justify-center items-center relative">
        <div class="w-full max-w-sm px-2">
            <template  v-if="!isEval">
                <img src="@/assets/images/Graphics/Check-big.svg" class="block mx-auto mt-24"/>
                <p class="text-center text-azuloscuro text-sm mt-5">
                    !Enhorabuena!
                </p>

                <div>
                    <p class="text-center text-azuloscuro text-sm">
                        Lo has hecho muy bien.
                    </p>
                </div>
            </template>

            <div v-if="!isEval">
                <div class="mt-10">
                    <h1 class="text-center text-azuloscuro mb-6 font-semibold text-xl">Valora esta Pill</h1>
                    <div class="flex justify-around text-center">
                        <div v-on:click="evaluate(1)" class="border shadow px-3 py-3 rounded-lg bg-white">
                            <img  src="@/assets/images/cara-triste.svg"
                                  class="object-contain h-10"/>
                        </div>
                        <div v-on:click="evaluate(2)" class="border shadow px-3 py-3 rounded-lg bg-white">
                                <img  src="@/assets/images/cara-neutral.svg"
                                     class="object-contain h-10"/>
                        </div>
                        <div v-on:click="evaluate(3)" class="border shadow px-3 py-3 rounded-lg bg-white">
                                <img  src="@/assets/images/cara-contenta.svg"
                                     class="object-contain h-10"/>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="mt-10">
                <div v-if="number == 3" class="pt-12">
                    <div class="w-full mb-4 mt-4 self-center">
                        <router-link
                                to="/"
                                class="">
                        <img src="@/assets/images/pill_completado_image.svg"
                             class="w-full self-center" />
                        </router-link>
                    </div>
                    <router-link
                            to="/"
                            class="">
                        <button class="absolute right-0 top-0 mt-4 mr-4 rounded-sm shadow-lg px-4 py-2 bg-white">x</button>
                    </router-link>
                </div>
                <div v-else>
                    <div v-if="!isCommented" class="w-full mb-4 mt-4 self-center px-8">
                        <h1 class="text-center text-azuloscuro mb-6 font-semibold text-xl">¿Qué podemos mejorar?<br>¡Gracias!</h1>
                        <textarea class="bg-white rounded-lg p-4 border border-gray-300 w-full" style="-webkit-appearance: none"
                                  rows="5" v-model="comments">
                        </textarea>

                        <button v-on:click="comment" class="bg-azuloscuro hover:bg-greenlight text-white py-2 px-4 rounded-full focus:outline-none w-full"
                                type="button">
                            Comentar
                        </button>
                    </div>
                    <div v-else class="pt-12">
                        <div class="w-full mb-4 mt-4 self-center">
                            <router-link
                                    to="/"
                                    class="">
                                <img src="@/assets/images/pill_completado_image.svg"
                                     class="w-full self-center" />
                            </router-link>
                        </div>
                        <router-link
                                to="/"
                                class="">
                            <button class="absolute right-0 top-0 mt-4 mr-4 rounded-sm shadow-lg px-4 py-2 bg-white">x</button>
                        </router-link>
                    </div>
                </div>
                <div class="mt-10" v-if="isEval && number !== 3 && !isCommented">
                    <router-link
                    to="/"
                    class="">
                        <div class="flex justify-left mb-4 px-4">
                            <div class="underline text-center w-full pt-1">
                                Saltar
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Utilities from '@/plugins/Utilities.js'
    import Zondicon from 'vue-zondicons'
    import users from "@/plugins/api/users/users";
    import setTitle from "../plugins/title";

    const PillsCompletado = {
        name: 'PillsCompletado',
        layout: '',
        components: {
            Zondicon
        },
        data: function(){
            return {
                assignedPill: null,
                isEval: false,
                isCommented: false,
                number: 0,
                comments: ''
            }
        },
        beforeMount: function(){
            if(!Utilities.isLogged()){
                this.$router.push({ name:'login' })
            }

            this.assignedPill = this.$route.params.i;

            if (!this.assignedPill) {
                this.$router.push({ name: 'home' })
            }
        },
        methods: {
            async evaluate(number){
                this.assignedPill.rating = number;
                this.number = number;
                await users
                    .putAssignedPill(this.assignedPill).then(response => {
                        this.isEval = true;
                    })
                    .catch(e => {
                        console.log(e);
                    });
            },
            async comment(){
                this.assignedPill.comments = this.comments;
                console.log(this.comments);
                await users
                    .putAssignedPill(this.assignedPill).then(response => {
                        this.isCommented = true;
                    })
                    .catch(e => {
                        console.log(e);
                    });
            }
        },
        created () {
            setTitle('Pill Completada')
        }
    }

    export default PillsCompletado;
</script>
